import { Component } from 'react'

/** Atrapa errores de render para que la app no se quede en blanco. */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary catched:', error, info)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 24, maxWidth: 700, margin: '60px auto',
          background: '#FEE2E2', border: '2px solid #EF4444',
          borderRadius: 12, fontFamily: 'Inter, sans-serif',
        }}>
          <h2 style={{ marginTop: 0, color: '#991B1B' }}>⚠️ Algo se rompió</h2>
          <p style={{ color: '#991B1B', fontSize: 14 }}>
            La página tuvo un error y no se pudo renderizar. Te paso el detalle técnico:
          </p>
          <pre style={{
            background: '#fff', padding: 12, borderRadius: 6,
            fontSize: 12, overflow: 'auto', whiteSpace: 'pre-wrap',
            color: '#1f2937',
          }}>
            {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
          </pre>
          <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
            <button
              onClick={() => { this.setState({ error: null }); window.location.reload() }}
              style={{ background: '#1A3461', color: '#fff', border: 0, padding: '10px 18px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' }}
            >Recargar página</button>
            <button
              onClick={() => { this.setState({ error: null }); window.history.back() }}
              style={{ background: '#fff', color: '#1A3461', border: '1px solid #1A3461', padding: '10px 18px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' }}
            >← Volver</button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
